import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Title } from 'components/layout'
import styles from './tasks-email-revision-reason.styl'

export default class TasksEmailRevisionReason extends Component {
  static propTypes = {
    reason: PropTypes.string
  }

  render() {
    const { reason } = this.props

    return (
      <div>
        <Title
          h2
          intlKey="label.undelivered_mail_reason"
        >
          Reason for non-delivery of email
        </Title>
        {reason
          ? <span className={styles.reason}>{reason}</span>
          : <FormattedMessage id="label.no_note" defaultMessage="No note" />}
      </div>
    )
  }
}
